import React from "react";
import PropTypes from "prop-types";
import { SIGNOL_COLOUR_NAMES } from "@signolteam/shared/colours";
import { AppUtils, SignolUtils } from "@src/utils";
import { COMMON_CONTROLS } from "../../stories/utils/common-controls";

const TabSelector = ({
  options = [],
  selectedColor = "primary",
  selected,
  position = "end",
  onClick,
  margins = true,
  trackingActionKey = undefined,
}) => {
  options = options
    .filter((option) => ["string", "object"].includes(typeof option))
    .map((option) => {
      if (typeof option === "string") {
        return {
          key: option,
          label: option,
        };
      } else if (typeof option === "object" && option.key && option.label) {
        return {
          key: option.key,
          label: option.label,
        };
      }
    });
  return (
    <div className={margins ? "m-2" : ""}>
      <div className={`flex justify-${position}`}>
        <span
          className={`relative z-0 inline-flex shadow-sm rounded-xl bg-white ${
            margins ? "mr-4 my-4" : ""
          }`}
        >
          {options.map((option) => (
            <button
              key={option.key}
              type="button"
              className={`relative inline-flex items-center px-4 py-1 rounded-xl text-sm
            leading-5 font-bold cursor-pointer focus:z-10 focus:outline-none focus:border-blue-300
            focus:shadow-outline-blue transition ease-in-out duration-150
            ${
              option.key === selected
                ? `bg-${selectedColor}-500 text-white`
                : ""
            }`}
              onClick={async () => await onClick(option.key, option.label)}
              {...(!!trackingActionKey
                ? SignolUtils.makeTrackableDataAttributes({
                    actionKey: trackingActionKey,
                    tabKey: option.key,
                    tab: option.label,
                  })
                : {})}
            >
              {option.label}
            </button>
          ))}
        </span>
      </div>
    </div>
  );
};

export const tabSelectorControls = {
  options: {
    propType: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
    ]),
    description: "Array of tab options (strings or {value, label} objects)",
    defaultValue: ["Tab 1", "Tab 2", "Tab 3"],
    controlType: "object",
  },
  selectedColor: {
    ...COMMON_CONTROLS.colour_name_shaded,
    description: "Color for the selected tab indicator",
    defaultValue: "primary",
  },
  selected: {
    propType: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
    ]),
    description: "Currently selected tab value",
    controlType: "text",
    defaultValue: "Tab 1",
  },
  onClick: {
    propType: PropTypes.func.isRequired,
    description: "Handler for tab selection",
    disable: true,
  },
  trackingActionKey: COMMON_CONTROLS.trackingActionKey,
};

TabSelector.propTypes = AppUtils.getPropTypeFromControls(tabSelectorControls);

export default TabSelector;
